export default "__VITE_ASSET__BMG1LGDT__"